import ContentShowItem from "MiniSiteComponents/Carousel/Carousel.interface";
import ComponentImage from "GeneralComponents/ComponentImage";
import Helper from "Interfaces/Helper";
import CustomLinkButton from "GeneralComponents/CustomLinkButton";
import { decodeHtmlEntities } from "../../../../Interfaces/utils/Utils";

const Tab = ({ contentShowItem, linkIconType, linkTarget }: { contentShowItem: ContentShowItem, linkIconType: string, linkTarget?:string }) => {

    const dir = getComputedStyle(document.documentElement).direction;
    const hasContent = !!contentShowItem.content;
    const isLink = (!hasContent && ((contentShowItem.link.url.startsWith("/") || contentShowItem.link.url.startsWith("http")) || (contentShowItem.url.startsWith("/") || contentShowItem.url.startsWith("http") || contentShowItem.link.url.startsWith("tel:"))));

    return (

        <div className={`${hasContent ? 'tab-header ' : ''} mst-tabItem-header`}>

            <div className="mb-2 mst-tabItem-header-contents text-center " >

                <div>
                    {
                        contentShowItem.image &&

                        <ComponentImage
                            image={contentShowItem.image}
                            imageClass=""
                            mobileImage={null}
                            mobileImageClass=""
                            wrapperDivClass="mst-tabItem-Img mb-4"
                            cropAlias="squareImage" />
                    }

                    <Title
                        hasContent={hasContent}
                        isLink={isLink}
                        linkIconType={linkIconType}
                        title={contentShowItem.title}
                    />

                    <Description description={contentShowItem.richDescription} />

                    {
                        isLink &&
                        <CustomLinkButton
                            title={contentShowItem.title}
                            pageUrl={contentShowItem.url}
                            link={contentShowItem.link}
                            isBtn={false}
                            linkClass="mst-overlay-link"
                            dir={dir}
                            linkTarget={linkTarget}
                        />
                    }

                </div>

            </div>

            <TriangleUpArrow />
        </div>
    );
}

export default Tab;

const Title = ({ linkIconType, hasContent, isLink, title }: { isLink: boolean; linkIconType: string; hasContent: boolean; title: string; }) => {

    const isClickable = isLink || hasContent;
    
    return (
        <div className="mst-tabItem-Title regular-txt mb-2">
            <div className={`${isLink || hasContent ? "tab-has-link" : ""}`}>
                <span>{title} </span>
                {
                    isClickable &&
                    <span className="mst-arrow">
                        <i className={`fa fa-fw ${linkIconType} `} aria-hidden="true"></i>
                    </span>
                }
            </div>
        </div>
    )
}

const Description = ({ description }: { description: string; }) => {
    const show = description && typeof description == 'string';
    return show && <span className="mst-tabItem-shortDesc regular-txt"
        dangerouslySetInnerHTML={{ __html: decodeHtmlEntities(description) }}
    />
}

const TriangleUpArrow = () => <div className="mst-tabItem-triangleUp primary-color mx-auto"></div>
